import Store from "../store";
const mixin = {
  data() {
    return {};
  },
  computed: {
    test1: () => 123
  },
  methods: {
    /**
     * 格式化时间
     * @param {string|number|object|Array} dateTime - 时间，可以是一个字符串、时间戳、表示时间的对象、Date对象或者******表示时间的数组
     * @param {string} [fmt] - 格式
     * @returns {string} 返回格式化后的日期时间，默认格式：2018年1月11日 15:00
     * @see [momentjs]{@tutorial http://momentjs.cn/}
     */
    formatDate(dateTime, fmt = "YYYY年M月DD日 HH:mm:ss") {
      if (!dateTime) {
        return "";
      }
      return dateTime;
    },
    PUSH(data) {
      this.$router.push(data);
    },
    REPLACE(data) {
      this.$router.replace(data);
    },
    GO(data) {
      this.$router.go(data);
    },
    loginOut() {
      localStorage.removeItem("userInfo");
      this.REPLACE({ name: "login" });
      // window.location.href = "/"
    },
    typeStringToArry(string) {
      // 将两头有[]的字符串转为数组
      if (
        string &&
        typeof string == "string" &&
        string.substr(0, 1) == "[" &&
        string.substr(string.length - 1, 1) == "]"
      ) {
        if (string.substr(1, string.length - 2) != "") {
          string = string
            .substr(1, string.length - 2)
            .split(",")
            .map(item => {
              if (
                (item.substr(0, 1) == "'" &&
                  item.substr(item.length - 1, 1) == "'") ||
                (item.substr(0, 1) == '"' &&
                  item.substr(item.length - 1, 1) == '"')
              ) {
                return item.substr(1, item.length - 2);
              }
              return item;
            });
        } else {
          string = [];
        }
        return string;
      } else if (typeof string == "object" && string != null) {
        return string;
      }
      return [];
    },
    decodeURL(url) {
      return decodeURIComponent(url || "");
    },
    encodeURL(url) {
      return encodeURIComponent(url);
    },
    getUrlFileName(fileUrl) {
      let str = fileUrl;
      str = str.substring(str.lastIndexOf("/") + 1);
      str = str.substring(0, str.lastIndexOf("."));
      return str;
    },
    // 数组对象排序 参数(排序数组，排序依据对象下标) 注意：下标以string类型传入
    sortByKey(array, key) {
      return array.sort(function(a, b) {
        var x = a[key];
        var y = b[key];
        return x < y ? -1 : x > y ? 1 : 0;
      });
    },
    // 邮箱验证
    judgeEmail(email) {
      return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
        email
      );
    },
    // 手机号校验
    judgePhone(val = "") {
      return /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(val);
    },
    // 密码校验
    judgePassword(val = "") {
      // 长度为5-20,不能有汉字
      return val.length >= 5 && val.length <= 20 && /^[^\u4e00-\u9fa5]+$/.test(val)
    },
    // 处理时间显示
    handleTime(time) {
      return time ? this.moment(time).format("YYYY-MM-DD HH:mm:ss") : "N/A";
    },
    // 管理员权限
    adminShow() {
      return localStorage.getItem("userRoles") == 1;
    },
    // 门店权限
    shopShow() {
      return localStorage.getItem("userRoles") == 2;
    },
    // 金额显示
    handleMoney(val = 0) {
      return (val / 100).toFixed(2);
    },
    // 输入框空提示
    emptyTip(msg) {
      this.$message({
        type: "warning",
        message: msg + this.$t("m.emptyTip")
      });
    },
    // 历史时间选择限制
    timeSelectLimit() {
      return {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        }
      };
    },
    // 权限判断
    judgeAuthority(str) {
      if (str.split(",").length > 1) {
        let flag = false;
        str.split(",").forEach(item => {
          if (
            Store.state.userInfo.permissions &&
            Store.state.userInfo.permissions.indexOf(
              Store.state.userInfo.permissions[item]
            ) != -1
          ) {
            flag = true;
          }
        });
        return flag;
      } else {
        return (
          Store.state.userInfo.permissions &&
          Store.state.userInfo.permissions.indexOf(str) != -1
        );
      }
    },
    // 获取UTC时间
    getUTCTime() {
      let date = new Date();
      return new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds()
      ).getTime();
    },
  }
};
export default mixin;
